import {cloneDeep} from 'lodash'

angular.module('clientDashboardApp').service('cacheService', ['$cacheFactory', '$http', '$q', '$interval', function ($cacheFactory, $http, $q, $interval) {

  function CacheService() {
    $http.defaults.cache = false
    this.http_ = $http
    this.cacheTypes = ['user', 'group', 'location', 'account', 'userGroup', 'userLocation', 'groupLocation', 'competitor', 'userRole']
    this.initCache()
  }

  CacheService.prototype.initCache = function () {
    _.each(this.cacheTypes, item => $cacheFactory(item, {capacity: 10}))

    $interval(() => _.each(this.cacheTypes, item => this.refreshCache(item)), 300000)
  }

  CacheService.prototype.refreshCache = function (type) {
    const cache = $cacheFactory.get(type)
    let dependentCaches = []
    if (type == 'group' || type == 'location') {
      _.each(this.cacheTypes, function (item) {
        if (item.match(new RegExp('^.+' + type + "$", "i"))) {
          dependentCaches.push($cacheFactory.get(item))
        }
      })
    } else if (type.search("Location") > 0) {
      let item = type.split("Location")[0]
      dependentCaches.push($cacheFactory.get(item))
    }
    if (dependentCaches.length) {
      _.each(dependentCaches, item => item.removeAll())
    }
    cache.removeAll()
  }

  CacheService.prototype.generateCacheKey = function (accountId, query) {
    let key = accountId ? accountId : "all"
    key += query ? "-" + query : ""
    return key
  }

  CacheService.prototype.cachedGetRequest = function (url, paramsObj, type, key) {
    const deferred = $q.defer()
    const cache = $cacheFactory.get(type)
    const cachedData = cache.get(key)
    if (!cachedData) {
      this.http_.get(url, paramsObj)
        .success(result => {
          cache.put(key, cloneDeep(result))
          deferred.resolve(result)
        })
        .error(() => deferred.reject())
    } else {
      deferred.resolve(cloneDeep(cachedData))
    }
    return deferred.promise
  }

  return new CacheService()

}])
